import React, { useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { listHeaderProducts } from "../actions/productActions";


function Categories() {
	const dispatch = useDispatch();
	const { error, loading, products } = useSelector(
		(state) => state.productHeaderList
	);

	useEffect(() => {
		dispatch(listHeaderProducts());
	}, [dispatch]);

	const getUniqueCategories = useMemo(() => {
		const uniqueCategories = new Set();
		products.forEach(({ category }) => uniqueCategories.add(category));
		return Array.from(uniqueCategories);
	}, [products]);

	const getBrandsForCategory = (category) => {
		const brandsInCategory = new Set();
		products.forEach(({ category: prodCategory, brand }) => {
			if (prodCategory === category) {
				brandsInCategory.add(brand);
			}
		});
		return Array.from(brandsInCategory);
	};

	return (
		<>
			{loading && <Loader />}
			{error && <Message variant="danger">{error}</Message>}
			{!loading && !error && (
				<NavDropdown
					menuVariant="dark"
					className="m-0  d-flex "
					title={
						<span>
							{/* <img
								src="../../../static/images/Product_Page.png"
								alt="products"
								style={{
									height: "17px",
									marginTop: "-4px",
									filter: "invert(100%)"
								}}
							/> */}
							<span className="fas fa-bag-shopping fs-5"></span>
							<span className="d-none d-md-inline-block">&nbsp;Products</span>
						</span>
					}>
							<Link
								className="text-capitalize text-white text-decoration-none"
								to={"/products"}>
								All products
							</Link>
					{getUniqueCategories.map((category) => (
						<NavDropdown
							menuVariant="dark "
							className="bg-dark p-0 m-0 "
							title={category}
							key={category}>
							
							{getBrandsForCategory(category).map((brand) => (
								<NavDropdown.Item className="" key={brand}>
									<Link
										className="text-capitalize text-white  text-decoration-none"
										to={`/categories/${category}/brands/${brand}`}>
										{brand}
									</Link>
								</NavDropdown.Item>
							))}
						</NavDropdown>
					))}
				</NavDropdown>
			)}
		</>
	);
}

export default Categories;
